var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "divBox",
    },
    [
      _c("search-page", {
        directives: [
          {
            name: "hasPermi",
            rawName: "v-hasPermi",
            value: ["platform:lottery-assistant:activity:list"],
            expression: "['platform:lottery-assistant:activity:list']",
          },
        ],
        ref: "searchPage",
        attrs: {
          "form-data": _vm.formData,
          columns: _vm.columns,
          request: _vm.getList,
        },
        scopedSlots: _vm._u([
          {
            key: "page-operation",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "mb8" },
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "hasPermi",
                            rawName: "v-hasPermi",
                            value: ["platform:lottery-assistant:activity:save"],
                            expression:
                              "['platform:lottery-assistant:activity:save']",
                          },
                        ],
                        attrs: { size: "small", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.handleAdd("isAdd")
                          },
                        },
                      },
                      [_vm._v("创建活动")]
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c(
                      "el-tabs",
                      {
                        on: { "tab-click": _vm.changeTab },
                        model: {
                          value: _vm.tab,
                          callback: function ($$v) {
                            _vm.tab = $$v
                          },
                          expression: "tab",
                        },
                      },
                      [
                        _c("el-tab-pane", {
                          attrs: { name: "all", label: "全部" },
                        }),
                        _c("el-tab-pane", {
                          attrs: { name: "status-1", label: "未开始" },
                        }),
                        _c("el-tab-pane", {
                          attrs: { name: "status-2", label: "进行中" },
                        }),
                        _c("el-tab-pane", {
                          attrs: { name: "winsStatus-0", label: "待开奖" },
                        }),
                        _c("el-tab-pane", {
                          attrs: { name: "winsStatus-1", label: "已开奖" },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "table-drawTime",
            fn: function (ref) {
              var row = ref.row
              return [
                row.activityLimitTime === 2
                  ? _c("div", [_vm._v("无限制")])
                  : _c("div", [
                      _vm._v(
                        _vm._s(row.drawStartTime) +
                          " 至 " +
                          _vm._s(row.drawEndTime)
                      ),
                    ]),
              ]
            },
          },
          {
            key: "table-winTime",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("div", [
                  _vm._v(
                    _vm._s(
                      row.activityType === 2
                        ? row.winsStatus
                          ? "已开奖"
                          : row.winTime
                        : "-"
                    )
                  ),
                ]),
              ]
            },
          },
          {
            key: "table-sortTmp",
            fn: function (scope) {
              return [
                _c(
                  "div",
                  [
                    _c("el-input-number", {
                      attrs: {
                        min: 0,
                        max: 9999,
                        step: 1,
                        controls: false,
                        type: "number",
                        placeholder: "请输入排序",
                      },
                      on: {
                        blur: function ($event) {
                          return _vm.handleSort(scope.row, scope.$index)
                        },
                      },
                      model: {
                        value: scope.row.sortTmp,
                        callback: function ($$v) {
                          _vm.$set(scope.row, "sortTmp", $$v)
                        },
                        expression: "scope.row.sortTmp",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "table-indexFlag",
            fn: function (ref) {
              var row = ref.row
              return [
                row.activityType === 2
                  ? _c(
                      "div",
                      [
                        _c("el-switch", {
                          attrs: {
                            "active-value": 1,
                            "inactive-value": 0,
                            "active-text": "开启",
                            "inactive-text": "关闭",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handleIndexFlagChange(row)
                            },
                          },
                          model: {
                            value: row.indexFlag,
                            callback: function ($$v) {
                              _vm.$set(row, "indexFlag", $$v)
                            },
                            expression: "row.indexFlag",
                          },
                        }),
                      ],
                      1
                    )
                  : [_vm._v("-")],
              ]
            },
          },
          {
            key: "table-bannerFlag",
            fn: function (ref) {
              var row = ref.row
              return [
                row.activityType === 2
                  ? _c(
                      "div",
                      [
                        _c("el-switch", {
                          attrs: {
                            "active-value": 2,
                            "inactive-value": 1,
                            "active-text": "开启",
                            "inactive-text": "关闭",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.handleBannerFlagChange(row)
                            },
                          },
                          model: {
                            value: row.bannerFlag,
                            callback: function ($$v) {
                              _vm.$set(row, "bannerFlag", $$v)
                            },
                            expression: "row.bannerFlag",
                          },
                        }),
                      ],
                      1
                    )
                  : [_vm._v("-")],
              ]
            },
          },
          {
            key: "table-append",
            fn: function () {
              return [
                _c("el-table-column", {
                  attrs: {
                    fixed: "right",
                    label: "操作",
                    align: "center",
                    "min-width": "220",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "header",
                      fn: function () {
                        return [
                          _c(
                            "p",
                            [
                              _c(
                                "span",
                                { staticStyle: { "padding-right": "5px" } },
                                [_vm._v("操作")]
                              ),
                              _c("right-toolbar", {
                                attrs: { columns: _vm.columns },
                                on: { refresh: _vm.refreshList },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "default",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.handleActivity(row, "detail")
                                  },
                                },
                              },
                              [_vm._v("详情")]
                            ),
                            _c("el-divider", {
                              attrs: { direction: "vertical" },
                            }),
                          ],
                          [
                            _c(
                              "a",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.handleActivity(row, "edit")
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            ),
                            _c("el-divider", {
                              attrs: { direction: "vertical" },
                            }),
                          ],
                          _c(
                            "el-dropdown",
                            { attrs: { trigger: "click" } },
                            [
                              _c("span", { staticClass: "el-dropdown-link" }, [
                                _vm._v(" 更多"),
                                _c("i", {
                                  staticClass:
                                    "el-icon-arrow-down el-icon--right",
                                }),
                              ]),
                              _c(
                                "el-dropdown-menu",
                                {
                                  attrs: { slot: "dropdown" },
                                  slot: "dropdown",
                                },
                                [
                                  _c(
                                    "el-dropdown-item",
                                    {
                                      directives: [
                                        {
                                          name: "hasPermi",
                                          rawName: "v-hasPermi",
                                          value: [
                                            "platform:lottery-assistant:activity:save",
                                          ],
                                          expression:
                                            "['platform:lottery-assistant:activity:save']",
                                        },
                                      ],
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.handleActivity(row, "copy")
                                        },
                                      },
                                    },
                                    [_vm._v(" 复制活动 ")]
                                  ),
                                  row.activityType === 2
                                    ? [
                                        !row.winsStatus
                                          ? _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.handleActivityUser(
                                                      row,
                                                      "edit"
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" 抽奖码 ")]
                                            )
                                          : _c(
                                              "el-dropdown-item",
                                              {
                                                nativeOn: {
                                                  click: function ($event) {
                                                    return _vm.handleActivityUser(
                                                      row,
                                                      "detail"
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" 开奖记录 ")]
                                            ),
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("activity-users", {
        attrs: {
          "activity-id": _vm.activityUser.id,
          op: _vm.activityUser.type,
        },
        model: {
          value: _vm.activityUser.show,
          callback: function ($$v) {
            _vm.$set(_vm.activityUser, "show", $$v)
          },
          expression: "activityUser.show",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }